 <!--
  2019-3-6, AJK, created file.
 -->


<template>
  <div class="users container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"/>
    <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <div class="column is-one-third">
            <div class="card-container">
              <h1 class="title">Reset Password</h1>
              <b-field label="Email" >
                <b-input name="originalPassword" v-model="email" required/>
              </b-field>
              <div class="field is-grouped">
                <div class="control">
                  <button type="email" placeholder="email" class="button is-primary is-fullwidth">Reset Password</button>
                </div>
                <div class="control">
                  <router-link class="button is-text is-medium" :to="{name: 'login'}">Cancel</router-link>
                </div>
              </div>
            </div>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
  // // @ is an alias to /src
  import sharedAPI from '@/api/SharedAPI.js'

  export default {
    name: 'resetPassword',
    data () {
      return {
        isLoading: false,
        isFullPage: true,
        email: null,
        notificationDuration: 4000
      }
    },
    methods: {
      onSubmit: async function(){
        this.isLoading = true
        var scriptParameters = `{
          "userEmail" : "${this.email}"
        }`
        const result = await sharedAPI.runScript("Wholesale - Web Log - Reset Password", scriptParameters)
        var scriptResult = JSON.parse(result.response.scriptResult)
        console.log (scriptResult)
        this.isLoading = false
        // FM error
        if(result.messages[0].code !== "0"){
          this.$snotify.error( result.messages[0].message, "Error",
            {
              showProgressBar: false,
              position: 'rightBottom',
              icon: false,
              timeout: this.notificationDuration,
              closeOnClick: true,
              bodyMaxLength: 1000
            }
          )
          return
        }  
        // Script error
        if(scriptResult.code != 0){
          this.$snotify.error( scriptResult.message, "Error",
            {
              showProgressBar: false,
              position: 'rightBottom',
              icon: false,
              timeout: this.notificationDuration,
              closeOnClick: true,
              bodyMaxLength: 1000
            }
          )
          return
        }
        this.$snotify.success(`Your reset password has been sent to ${this.email}.`, "Success",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        this.$router.replace({ name: 'login'})
        return
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  } 
</style>